<template>
   <v-card class="mx-auto" :max-width="width">
      <v-toolbar color="primary">
         <v-toolbar-title class="white--text text-center"
            >COMENTARIOS</v-toolbar-title
         >
         <v-spacer></v-spacer>
      </v-toolbar>

      <v-list two-line>
         <v-list>
            <template v-if="comentarios.length > 0">
               <template v-for="(item, index) in comentarios">
                  <v-list-item :key="item.id">
                     <v-container class="fluid">
                        <v-list-item-content>
                           <!-- Quién y cuándo: encabeza el comentario para que la
                                lista se lea como un hilo de observaciones. -->
                           <div class="d-flex align-center mb-1">
                              <v-icon x-small color="primary" class="mr-1">
                                 fas fa-user-edit
                              </v-icon>
                              <span class="autor">
                                 {{ item.usuario || 'Usuario no registrado' }}
                              </span>
                              <v-spacer></v-spacer>
                              <span class="fecha">{{ item.fecha }}</span>
                           </div>

                           <div class="comentario" v-text="item.comentario"></div>
                        </v-list-item-content>
                     </v-container>
                  </v-list-item>

                  <v-divider
                     v-if="index < comentarios.length - 1"
                     :key="item.id + 'b'"
                  ></v-divider>
               </template>
            </template>
            <template v-else>
               <h4 class="text-center sin-comentarios">Sin comentarios</h4>
            </template>
         </v-list>
      </v-list>
   </v-card>
</template>

<script>
export default {
   props: {
      width: {
         type: Number,
         default: 500
      },
      comentarios: {
         type: Array,
         default: function () {
            return []
         }
      }
   },
   data: () => ({})
}
</script>

<style lang="scss" scoped>
/* Gris y sin negrita: deja claro que es un estado vacío y no un comentario. */
.sin-comentarios {
   color: rgba(0, 0, 0, 0.38);
   font-weight: 400;
   padding: 16px 0;
}
.autor {
   font-size: 13px;
   font-weight: 600;
   color: var(--v-primary-base);
}
.fecha {
   font-size: 12px;
   color: rgba(0, 0, 0, 0.55);
}
/* pre-wrap respeta los saltos de línea que escribió el asesor;
   break-word evita que un texto largo sin espacios desborde la tarjeta. */
.comentario {
   background: #f5f5f5;
   border-left: 3px solid var(--v-primary-base);
   border-radius: 4px;
   padding: 8px 10px;
   font-size: 13px;
   line-height: 1.45;
   color: rgba(0, 0, 0, 0.8);
   white-space: pre-wrap;
   word-break: break-word;
}
</style>
